import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../libs/css/date-picker.css';
import LoadingSpinnerSmall from '../LoadingSpinner/LoadingSpinnerSmall';
import { API_ROUTES } from '../../../utils/constants';

const SubCountReportFilter = ({ onSubmit, isLoading, objectToFormData, isAuthExpired }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [networkId, setNetworkId] = useState('1');
    const [type, setType] = useState('daily');
    const [serviceId, setServiceId] = useState('');
    const [serviceList, setServiceList] = useState([]);
    const [loadingServices, setLoadingServices] = useState(false);
    const [error, setError] = useState('');

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const filteredServiceList = networkId
        ? serviceList.filter((s) => String(s.network_id) === String(networkId))
        : serviceList;

    const handleNetworkChange = (e) => {
        setNetworkId(e.target.value);
        setServiceId('');
    };

    const formatDate = (date, endOfDay = false) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day} ${endOfDay ? '23:59:59' : '00:00:00'}`;
    };

    useEffect(() => {
        const fetchServices = async () => {
            setLoadingServices(true);
            const user_id = localStorage.getItem('user_id');
            try {
                const response = await fetch(API_ROUTES.VIEW_SERVICES, {
                    method: 'POST',
                    body: objectToFormData({ service_id: user_id }),
                    headers: { token: userData?.responseDetails?.token },
                });
                const responseJSON = await response.json();
                isAuthExpired(responseJSON);
                if (responseJSON.status.toString() === '200') {
                    const unique = responseJSON.data.filter((s, i, arr) =>
                        i === arr.findIndex(x => x.serviceId === s.serviceId)
                    );
                    setServiceList(unique);
                }
            } catch (e) {
                console.log('Error fetching services:', e);
            } finally {
                setLoadingServices(false);
            }
        };
        fetchServices();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!startDate) { setError('Please select a start date'); return; }
        if (!endDate) { setError('Please select an end date'); return; }
        if (endDate < startDate) { setError('End date cannot be before start date'); return; }
        if (!type) { setError('Please select a report type'); return; }
        setError('');
        onSubmit({
            fro: formatDate(startDate),
            to: formatDate(endDate, true),
            network_id: networkId || 'all',
            type,
            serviceId,
        });
    };

    return (
        <div className="card mb-4 mt-25 p-5">
            <form onSubmit={handleSubmit} className="row g-3 align-items-end">
                <div className="col-md-2">
                    <DatePicker
                        selected={startDate}
                        className="filter_text"
                        onChange={(date) => { setStartDate(date); setError(''); }}
                        dateFormat="yyyy-MM-dd"
                        isClearable
                        placeholderText="Start Date"
                        calendarClassName="large-calendar"
                    />
                </div>

                <div className="col-md-2">
                    <DatePicker
                        selected={endDate}
                        className="filter_text"
                        onChange={(date) => { setEndDate(date); setError(''); }}
                        dateFormat="yyyy-MM-dd"
                        isClearable
                        placeholderText="End Date"
                        calendarClassName="large-calendar"
                        minDate={startDate}
                        disabled={!startDate}
                    />
                </div>

                <div className="col-md-2">
                    <select className="filter_text" value={networkId} onChange={handleNetworkChange}>
                        <option value="">-Network (All)-</option>
                        <option value="1">MTN</option>
                        <option value="2">GLO</option>
                        <option value="3">Airtel</option>
                        <option value="4">9Mobile</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <select className="filter_text" value={type} onChange={(e) => setType(e.target.value)}>
                        <option value="">-Type-</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </select>
                </div>

                <div className="col-md-2">
                    {loadingServices && <LoadingSpinnerSmall />}
                    <select
                        className="filter_text"
                        value={serviceId}
                        onChange={(e) => setServiceId(e.target.value)}
                        disabled={loadingServices}
                        style={{ opacity: loadingServices ? 0.4 : 1 }}
                    >
                        <option value="">-Service (All)-</option>
                        {filteredServiceList.map((s, i) => (
                            <option key={`${s.serviceId}_${i}`} value={s.serviceId}>{s.serviceName}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? 'Loading...' : <><i className="fa fa-search"></i> Filter</>}
                    </button>
                </div>

                {error && (
                    <div className="col-12 mt-2">
                        <div className="alert alert-danger" role="alert">{error}</div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default SubCountReportFilter;
